import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchUsers } from 'actions/users';
import { fetchAllVendors } from 'actions/vendor-request';
import {
  HeaderFlexRow,
  Container,
  PlainButton,
  HeadingTitle,
} from 'components/styled-components';
import { Section } from 'containers/Manage-Questionnaire/styled-components';
import Controls from 'components/users/controls';
import clone from 'lodash/clone';
import Pagination from 'components/pagination';
import UserTable from 'components/users/table';
import UserDrawer from 'components/users/drawer';
import Loading from 'components/loading';
import {
  fetchAllDepartments,
  fetchAllRoles,
  fetchAllUserStatus,
} from 'actions/utils';
import { createUser, updateUser, resendEmail } from 'api/users';
import { pluckFromArray } from 'utils/functions';
import { Intent } from '@blueprintjs/core';
import { AppToaster } from 'components/AppToaster';
import hasPermission from 'utils/hasPermission';
import Permissions from 'utils/permissions';
import reduce from 'lodash/reduce';
import isEqual from 'lodash/isEqual';

const initialUserState = {
  firstName: '',
  lastName: '',
  email: '',
  status: null,
  role: null,
  thirdParties: null,
};

class ManageUsers extends Component {
  state = {
    isOpen: false,
    user: clone(initialUserState),
    initialUser: {},
    newUser: false,
    currentPage: 0,
    perPage: 10,
    initialUserDepartmentString: '',
  };

  componentDidMount() {
    this.props.fetchUsers({
      limit: this.state.perPage,
      start: this.state.currentPage,
    });
    this.props.fetchAllVendors();
    this.props.fetchAllDepartments();
    this.props.fetchAllRoles();
    this.props.fetchAllUserStatus();
  }

  handleEditClick = _user => {
    const user = clone(_user);
    user.department = pluckFromArray(
      this.props.departments,
      'departmentName',
      user.department
    );
    user.role = pluckFromArray(this.props.roles, 'roleName', user.role);
    user.thirdParties = user.thirdParties === null ? null : user.thirdParties.map(tp => pluckFromArray(
      this.props.vendors,
      'vendorName',
      tp.thirdParty
    ));
    user.status = pluckFromArray(this.props.status, 'statusName', user.status);
    const initialUser = clone(user);
    this.setState({
      isOpen: true,
      user,
      initialUser,
      initialUserDepartmentString: _user.department,
    });
  };

  handleAddUserClick = () => {
    this.setState({ isOpen: true, newUser: true });
  };

  resetUser = () => this.setState({ user: clone(initialUserState) });

  handleCloseDrawer = () => {
    this.setState({
      isOpen: false,
      newUser: false,
      query: null,
      user: clone(initialUserState),
    });
  };

  handleTextChange = e => {
    const { name, value } = e.target;
    const { user } = this.state;
    user[name] = value;
    this.setState({ user });
  };

  handleSelectChange = (name, value) => {
    const { user } = this.state;
    user[name] = value;
    this.setState({ user });
  };

  handlePageClick = currentPage => {
    this.setState({ currentPage }, () =>
      this.props.fetchUsers({
        limit: this.state.perPage,
        start: this.state.currentPage * this.state.perPage,
        query: this.state.query,
      })
    );
  };

  handlePerPageChange = perPage => {
    this.setState({ perPage: perPage.value, currentPage: 0 }, () =>
      this.props.fetchUsers({
        limit: this.state.perPage,
        start: this.state.currentPage * this.state.perPage,
        query: this.state.query,
      })
    );
  };

  handleSaveUser = (originalUser, user, actions) => {
    //compare the originalUser obj to the values sent by formik
    const userObj = reduce(
      originalUser,
      (result, value, key) => {
        const updatedValue = user[key];
        if (!!updatedValue) {
          if (!isEqual(value, updatedValue)) result[key] = updatedValue;
        }
        return result;
      },
      {}
    );
    if (!this.state.newUser && user.userID) {
      //update
      updateUser(user.userID, userObj)
        .then(res => {
          AppToaster.show({
            message: res.data.message,
            intent: Intent.SUCCESS,
          });
          actions.setSubmitting(false);
          this.props.fetchUsers({
            limit: this.state.perPage,
            start: this.state.currentPage * this.state.perPage,
            query: this.state.query,
          });
          this.handleCloseDrawer();
        })
        .catch(err => {
          actions.setSubmitting(false);
          AppToaster.show({
            message: err.response.data.message,
            intent: Intent.DANGER,
          });
        });
    } else {
      createUser(user)
        .then(res => {
          AppToaster.show({
            message: res.data.message,
            intent: Intent.SUCCESS,
          });
          actions.setSubmitting(false);
          this.props.fetchUsers({
            limit: this.state.perPage,
            start: this.state.currentPage * this.state.perPage,
            query: this.state.query,
          });
          this.handleCloseDrawer();
        })
        .catch(err => {
          actions.setSubmitting(false);
          AppToaster.show({
            message: err.response.data.message,
            intent: Intent.DANGER,
          });
        });
    }
  };

  handleResendEmail = (userID, emailType) => {
	resendEmail(userID, emailType)
		.then(response => {
			AppToaster.show({
				message: response.data.message,
				intent: Intent.SUCCESS,
			});
		})
        .catch(err => {
          AppToaster.show({
            message: err.response.data.message,
            intent: Intent.DANGER,
          });
        });
  };

  handleSaveAndAddAnotherUser = (user, actions) => {
    createUser(user)
      .then(res => {
        AppToaster.show({
          message: res.data.message,
          intent: Intent.SUCCESS,
        });
        actions.setSubmitting(false);
        this.props.fetchUsers({
          limit: this.state.perPage,
          start: this.state.currentPage * this.state.perPage,
          query: this.state.query,
        });
        this.resetUser();
        actions.resetForm();
      })
      .catch(err => {
        actions.setSubmitting(false);
        AppToaster.show({
          message: err.response.data.message,
          intent: Intent.DANGER,
        });
      });
  };

  handleSearch = query => {
    this.setState({ query, currentPage: 0 }, () => {
      this.props.fetchUsers({
        limit: this.state.perPage,
        start: 0,
        query,
      });
    });
  };

  render() {
    const { users, isFetching, appUser } = this.props;
    return (
      <Container>
        <HeaderFlexRow>
          <HeadingTitle>User Management</HeadingTitle>
          {hasPermission(appUser.permissions, [
            Permissions.CREATE_ALL_USERS,
            Permissions.CREATE_THIRD_PARTY_USER,
          ]) && (
            <PlainButton onClick={this.handleAddUserClick}>
              ADD USER
            </PlainButton>
          )}
        </HeaderFlexRow>
        <Controls handleSearch={this.handleSearch} />
        <Section>
          {isFetching && <Loading size={100} />}
          {!isFetching && (
            <UserTable
              users={users.result}
              handleEditClick={this.handleEditClick}
              appUser={appUser}
              query={this.state.query}
            />
          )}
        </Section>
        <UserDrawer
          isOpen={this.state.isOpen}
          handleCloseDrawer={this.handleCloseDrawer}
          handleTextChange={this.handleTextChange}
          handleSelectChange={this.handleSelectChange}
          user={this.state.user}
          newUser={this.state.newUser}
          handleSaveUser={this.handleSaveUser}
          handleSaveAndAddAnotherUser={this.handleSaveAndAddAnotherUser}
          departments={this.props.departments}
          roles={this.props.roles}
          initialUser={this.state.initialUser}
          vendors={this.props.vendors}
          status={this.props.status}
          initialUserDepartmentString={this.state.initialUserDepartmentString}
		  handleResendEmail={this.handleResendEmail}
        />
        <Pagination
          numRecords={users.totalCount}
          perPage={this.state.perPage}
          currentPage={this.state.currentPage}
          onPageClick={this.handlePageClick}
          handlePerPageChange={this.handlePerPageChange}
        />
      </Container>
    );
  }
}

const mapStateToProps = state => ({
  users: state.users.portalUsers,
  isFetching: state.users.isUsersFetching,
  errorMessage: state.users.errorMessageUsers,
  vendors: state.vendorRequest.vendors,
  usersLoaded: state.users.portalUsersLoaded,
  departments: state.utils.departments,
  roles: state.utils.roles,
  status: state.utils.status,
});

ManageUsers = connect(
  mapStateToProps,
  {
    fetchUsers,
    fetchAllVendors,
    fetchAllDepartments,
    fetchAllRoles,
    fetchAllUserStatus,
  }
)(ManageUsers);

export default ManageUsers;
